import moment from 'moment';

import { Base } from './_base.model';

export class SpeakerAgreement extends Base {
  id: number;
  type: string;
  signature: string;
  client_signature: string;
  initial: string;
  signature_date: Date;
  client_signature_date: Date;
  effective_date: Date;
  expiration_date: Date;
  uploaded_date: Date;
  created_date: Date;
  file: string;
  w9_file: string;
  specialty: string;
  tier: string;
  sub_level: string;
  hourly_rate: string;
  cap: number;
  program_cap: number;
  program_format_cap: number;
  program_format_cap_type: string;
  tier_review_file: string;
  honoraria_rates: any;
  contract_travel_distance: string;
  address_of_record_address1: string;
  address_of_record_address2: string;
  address_of_record_address3: string;
  address_of_record_city: string;
  address_of_record_state: string;
  address_of_record_zip: string;
  address_of_record_latitude: number;
  address_of_record_longitude: number;

  deserialize(obj: any) {
    Object.assign(this, obj);
    [
      'signature_date',
      'client_signature_date',
      'effective_date',
      'expiration_date',
      'uploaded_date',
      'created_date',
    ].forEach(field => {
      if (this[field]) {
        this[field] = moment(this[field]).toDate();
      }
    });
    if (!this.created_date && this.uploaded_date) {
      this.created_date = moment(this.uploaded_date).toDate();
    }
    return this;
  }
}
